module.exports = __webpack_public_path__ + "static/media/explore-the-docs.e1496c90.svg";